export function mainMenu() {

    let menu        = document.querySelector('.js-menu');
    let menuBtn     = document.querySelector('.js-menu-btn');
    let menuIcons   = menuBtn.querySelectorAll('img');

    // Methods
    let openMenu = () => {
        menu.classList.add('is-active');
    }

    let closeMenu = () => {
        menu.classList.remove('is-active');
    }

    let toggleMenu = () => {
        menu.classList.toggle('is-active');
    }

    menuBtn.addEventListener('click', () => {
       toggleMenu();
        menuIcons.forEach((icon) => icon.classList.toggle('d-none'));

    });

    return {
        open: openMenu,
        close: closeMenu,
        toggle: toggleMenu
    }
}
